import type { IUserInfo } from '../shared/models/identity/user-info';

const KEY = 'epos.offline.session-user.v1';

export const saveOfflineSessionUser = (user: IUserInfo | null | undefined) => {
  if (!user) return;
  try {
    localStorage.setItem(KEY, JSON.stringify(user));
  } catch {
    // El cache de sesión es auxiliar; una cuota llena no debe romper la venta online.
  }
};

export const getOfflineSessionUser = (): IUserInfo | null => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as IUserInfo) : null;
  } catch {
    return null;
  }
};

export const clearOfflineSessionUser = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // no-op
  }
};
